import React from "react";
import { useTranslation } from "react-i18next";
import EnContent from "./en.md";
import StaticPageLayout from "../StaticPageLayout";

export default function Faq() {
  const { t } = useTranslation();
  return <StaticPageLayout title={t("faq.title")} subtitle={t("faq.subtitle")} mdContent={EnContent} />;
}
